import {useDispatch} from 'react-redux';
import {addItemsBrowseMore} from '~/actions/AnalyticsActions';
import {metrics} from '~/vendor/metrics';

export const useMetrics = ({
  addItemsPath,
  quoteFormPath,
  inSkirt,
  fireSkirtTag
}) => {
  const dispatch = useDispatch();

  const locationMap = () => {
    if (addItemsPath) return 'bottom bar';
    if (quoteFormPath) {
      return window.location.hash.includes('quote') ? 'quote' : 'buy';
    }
    return 'skirt';
  };

  const fireStyleMetrics = (style, selectedProductId) => {
    const location = locationMap();

    if (inSkirt) {
      selectedProductId === style.id
        ? fireSkirtTag('color')
        : fireSkirtTag('style');
    }

    if (selectedProductId !== style.id) {
      metrics.fireEvent(
        'complementary styles',
        addItemsPath ? 'add products' : location,
        style.name
      );
    } else {
      metrics.fireEvent('additional color', location, style.name);
    }
  };

  const fireOrderAnythingMetrics = () => {
    dispatch(addItemsBrowseMore({source: 'color_matched_complements'}));
    metrics.fireEvent('complementary styles', locationMap(), 'Browse More');
  };

  return {
    fireStyleMetrics,
    fireOrderAnythingMetrics
  };
};
